import { render, staticRenderFns } from "./ConfigInputWrapper.vue?vue&type=template&id=52278705&scoped=true&"
import script from "./ConfigInputWrapper.vue?vue&type=script&lang=js&"
export * from "./ConfigInputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ConfigInputWrapper.vue?vue&type=style&index=0&id=52278705&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52278705",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52278705')) {
      api.createRecord('52278705', component.options)
    } else {
      api.reload('52278705', component.options)
    }
    module.hot.accept("./ConfigInputWrapper.vue?vue&type=template&id=52278705&scoped=true&", function () {
      api.rerender('52278705', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputWrapper.vue"
export default component.exports